import React from 'react';
import SpamFolderHint from './SpamFolderHint';
import './AuthForm.css';

const EmailVerificationNotice = ({ email, onGoToLogin, emailSendFailed }) => (
  <div className="auth-form auth-verification">
    <div className="auth-verification-icon" aria-hidden="true">✉️</div>
    <h2 className="auth-form-title">Confirme seu email</h2>

    {emailSendFailed ? (
      <>
        <p className="auth-verification-text">
          Sua conta foi criada, mas não conseguimos enviar o email de verificação agora.
        </p>
        <p className="auth-form-hint auth-verification-hint">
          Vá para o login com <strong>{email}</strong> e use &quot;Reenviar email de verificação&quot;.
        </p>
      </>
    ) : (
      <>
        <p className="auth-verification-text">
          Enviamos um link de verificação para:
        </p>
        <p className="auth-verification-email">{email}</p>
        <p className="auth-form-hint auth-verification-hint">
          Abra sua caixa de entrada e clique no link para ativar sua conta.
          Depois disso, volte aqui e faça login.
        </p>
        <p className="auth-form-hint auth-verification-hint">
          O email virá de <strong>contato@hakacompany.com.br</strong>.
        </p>
        <SpamFolderHint />
      </>
    )}

    <button
      type="button"
      onClick={onGoToLogin}
      className="btn btn-filled auth-form-submit"
    >
      <span>Ir para login</span>
    </button>
  </div>
);

export default EmailVerificationNotice;
